module.exports = __webpack_public_path__ + "img/right-leg_active.5bdb5912.png";